<template>
    <div>
        <LoginSocialComponent v-if="hasSocialLogins"/>

        <form>
            <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl multiple-rows-sp">
                <div class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp 
                            no-padding mb-2rem">
                    
                    <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                        {{ i18n.get('common.sign_up_what_email') }}
                    </div>
                    
                    <input :class="{'lw-brand-border': errors.first('email')}"
                           class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal 
                                  learnworlds-element"
                           v-model="form.email"
                           v-validate="'required|email'"
                           name="email" 
                           type="email"
                           :placeholder="i18n.get('common.sign_up_what_email')"/>
                </div>

                <div class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp 
                            no-padding mb-2rem">
                    
                    <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                        {{ i18n.get('common.sign_up_what_password') }}
                    </div>
                    
                    <input :class="{'lw-brand-border': errors.first('password') }"
                           class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal 
                                  learnworlds-element"
                           v-model="form.password"
                           v-validate="'required'"
                           name="password" 
                           type="password"
                           :placeholder="i18n.get('common.sign_up_what_password')"/>
                </div>
            </div>

            <div v-if="hasErrors" class="response-errors">
                <div class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
                    {{ errors.first('email') }}
                </div>
                
                <div class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
                    {{ errors.first('password') }}
                </div>
                
                <div v-for="(error, idx) in responseErrors"
                   :key="idx"
                   class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text"
                   v-html="getErrorMessage([error])"></div>
            </div>

            <div v-if="showSubmitButtons">
                <button @click.prevent="submit">
                    {{ i18n.get('common.login_login') }}
                </button>
            </div>
        </form>

        <div v-if="showForgotPassword" class="learnworlds-main-text learnworlds-main-text-small learnworlds-element">
            <a href="#" @click.prevent="showForgotPasswordForm">
                {{ i18n.get('common.login_forgot') }}
            </a>
        </div>
    </div>
</template>

<script>
    import axios from "commonjs/axios";
    import LoginSocialComponent from "./LoginSocialComponent";
    import AuthenticationMixin from "./AuthenticationMixin";

    export default {
        name: "LoginComponent",

        data() {
            return {
                form: {
                    email: '',
                    password: ''
                },
                responseErrors: []
            }
        },
        
        props: {
            showForgotPassword: {
                type: Boolean,
                default: true
            }
        },
        
        computed: {
            hasSocialLogins() {
                return false;
            },
            
            hasErrors() {
                return this.responseErrors.length || 
                    this.errors.first('email') || 
                    this.errors.first('password')
            }
        },

        methods: {
            submit() {
                return new Promise((resolve, reject) => {
                    this.$validator.validateAll().then(result => {
                        if (!result) {
                            return reject();
                        }
                        axios.post(`${this.clientURL}/api/signin`, {
                            ...this.form
                        }).then(response => {
                            if (response.data.success) {
                                this.successCallback(this.generateRedirectUrl(response));
                                resolve(this.generateRedirectUrl(response));
                            } else {
                                this.responseErrors = response.data.errors;
                                reject();
                            }
                        }).catch(error => {
                            reject();
                        });
                    }).catch(() => {
                        reject();
                    });
                });
            },

            authenticate() {
                return this.submit();
            },
            
            getErrorMessage(error) {
                return window.getErrorMessage(error);
            }
        },

        components: {
            LoginSocialComponent,
        },

        mixins: [
            AuthenticationMixin
        ],
    }
</script>
